<template>
	<form class="form-horizontal">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col sm="6" class="mx-auto mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Nama')}" label="Nama">
							{{ models.namaJenisUsaha }}
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';

	export default {
		name: 'ViewJenisUsahaUmk',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
					namaJenisUsaha: "",
				},
			}
		},
		created() {
			const _ = this
			_.getById();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`JenisUsahaUMK/${_.$route.params.id}`);
						const data = request.data.data;
						_.models.namaJenisUsaha = data.namaJenisUsaha;
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
		}
	}
</script>